export default {
    customerList: [
    ],
    customerHistory: null
}
